var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 77 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16524.592 2757.507)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.758,
    height: 15.469,
    rx: 7.734,
    transform: "translate(-16485.266 -2726.995) rotate(23)",
    fill: "#0ea79e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60.63,
    height: 15.469,
    rx: 7.734,
    transform: "translate(-16518.547 -2717.875) rotate(23)",
    fill: "#0ea79e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60.63,
    height: 15.469,
    rx: 7.734,
    transform: "translate(-16501.723 -2757.507) rotate(23)",
    fill: "#0ea79e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default __webpack_public_path__ + "static/media/logo-mobile.ca9702884796eb4339280129c735be70.svg";
export { ForwardRef as ReactComponent };